import { styled } from "@mui/material/styles";
import { Box, Button, IconButton } from "@mui/material";

export const Container = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  alignItems: "stretch",
  gap: "10px",
}));

export const AttachButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.primary,
  border: `2px solid ${theme.palette.text.primary}`,
  borderRadius: "8px",
  "&:hover": {
    color: theme.palette.text.primary,
  },
}));

export const InputWrapper = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  backgroundColor: "#ffffff",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "8px",
  padding: "4px 16px",
  display: "flex",
  alignItems: "center",
}));

export const SendButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.cta.backgroundPrimaryCta,
  color: "#000000",
  borderRadius: "8px",
  padding: "8px 20px",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "14px",
  minWidth: "auto",
  whiteSpace: "nowrap",
  "&:hover": {
    backgroundColor: "#00a5bb",
  },
  "&.Mui-disabled": {
    backgroundColor: "#333333",
    color: "#666666",
  },
}));
